module.exports = __webpack_public_path__ + "assets/ms.ed47ab96.svg";